import { Box, Typography, Container } from "@mui/material";
import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { useAnimation } from "../contexts/AnimationContext";

function DressCode() {
  const ref = useRef(null);
  const { animationStarted } = useAnimation();
  const isInView = useInView(ref, { once: true, margin: "0px" });

  return (
    <Container maxWidth="sm" sx={{ mt: 4, mb: 2.5 }}>
      <Box
        component={motion.div}
        ref={ref}
        initial={{ opacity: 0, y: 30 }}
        animate={
          isInView && animationStarted
            ? { opacity: 1, y: 0 }
            : { opacity: 0, y: 30 }
        }
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        sx={{
          textAlign: "center",
          px: 2,
        }}
      >
        <Typography
          sx={{
            fontFamily: '"Open Sans", sans-serif',
            fontSize: { xs: "0.8rem", sm: "1rem" },
            lineHeight: 2,
            color: "#2d4e66",
            textAlign: "center",
            mb: 3,
          }}
          align="justify"
        >
          <b>Dress code:</b> Formal (fato e gravata para os homens e vestido /
          macacão longo ou de cocktail para as senhoras)
        </Typography>
      </Box>
    </Container>
  );
}

export default DressCode;
